import { render, staticRenderFns } from "./RecordTableRow.vue?vue&type=template&id=2f751903"
import script from "./RecordTableRow.vue?vue&type=script&lang=js"
export * from "./RecordTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports